import { ReactNode } from 'react';

interface CardContainerProps {
  children: ReactNode;
  className?: string;
}

export const CardContainer = ({ children, className = '' }: CardContainerProps) => {
  return (
    <div className={`bg-white rounded-lg shadow-lg p-8 w-full max-w-md ${className}`}>
      {children}
    </div>
  );
};
